import type { Buffer } from "../model/buffer";
import { createBuffer, lastNormalModeCol } from "../model/buffer";
import type { Range } from "../model/range";
import type { RegisterContent } from "../model/registers";
import type { OperatorResult } from "./delete";
import { deleteCharRangeExclusive, normalizeRange, toExclusiveEnd } from "./range-edit";

/**
 * `c`: Rangeを削除して挿入モードへ入る位置を返す。
 * linewise（`cc`）は行そのものを削除せず、空行1行に置き換えてそこへ挿入する（本家vimの挙動）。
 */
export function applyChange(buffer: Buffer, range: Range): OperatorResult {
  const { from, to } = normalizeRange(range);

  if (range.kind === "linewise") {
    const deletedLines = buffer.lines.slice(from.line, to.line + 1);
    const newLines = [...buffer.lines.slice(0, from.line), "", ...buffer.lines.slice(to.line + 1)];
    return {
      buffer: createBuffer(newLines),
      cursor: { line: from.line, col: 0 },
      content: { lines: deletedLines, linewise: true },
    };
  }

  const exclusiveTo = range.kind === "inclusive" ? toExclusiveEnd(buffer, to) : to;
  const { buffer: nextBuffer, deletedLines } = deleteCharRangeExclusive(buffer, from, exclusiveTo);
  const col = Math.min(from.col, lastNormalModeCol(nextBuffer, from.line));
  return {
    buffer: nextBuffer,
    cursor: { line: from.line, col },
    content: { lines: deletedLines, linewise: false } satisfies RegisterContent,
  };
}
